import { useContext, useEffect, useState } from "react";
import Image from "../components/global/Image";
import Title from "../components/global/title/Title";
import ProjectFilter from "../components/projetsList/ProjectFilter";
import ProjectsList from "../components/projetsList/ProjectsList";
import Project from "../lib/models/Project";
import styles from "../components/projetsList/index.module.css";
import { ImageProjectContext } from "../contexts/imageProject";
/**
 *
 * @param {{staticProjects:Array}} param0
 * @returns
 */
const Projects = ({
  isInView,
  setBlock,
  name,
  staticProjects,
  staticTypes,
}) => {
  const {
    setShow: setShowImage,
    setSelectedProj,
    setProjects,
  } = useContext(ImageProjectContext);
  const [selected, setSelected] = useState(0);
  const [show, setShow] = useState(false);
  const [filters, setFilters] = useState(
    staticTypes.map(({ attributes: type }) => ({ ...type, active: true }))
  );
  const [projetFilter, setProjFilter] = useState(
    staticProjects.length ? staticProjects.map((e) => new Project(e)) : []
  );

  const toogleFilter = (id) => {
    let temp = [...filters];
    temp[id].active = !temp[id].active;
    setFilters(temp);
  };
  /**
   *
   * @param {Array<{types:{data:Array<{id:Number,attributes:{name:String}}>}}>} projects
   */
  const FilterProjets = (projects) => {
    return projects.filter((projet) => {
      if (!Array.isArray(projet?.types)) return true;
      let types = projet.types.map((type) => type.name);
      let activeFilters = filters.filter((f) => f.active).map((f) => f.name);
      types = types.filter((t) => activeFilters.some((f) => f == t));
      return Boolean(types.length);
    });
  };

  useEffect(() => {
    setProjFilter(FilterProjets(staticProjects.map((e) => new Project(e))));
  }, [filters]);

  useEffect(() => {
    setProjects(projetFilter);
    setSelected(0);
  }, [projetFilter]);

  useEffect(() => {
    if (!isInView) {
      setShow(false);
      setShowImage(false);
    }
    if (isInView)
      setTimeout(() => {
        setShowImage(true);
        setShow(true);
      }, 700);
  }, [isInView]);

  useEffect(() => {
    setSelectedProj(selected);
  }, [selected]);

  return (
    <>
      {/*  <Title number={3}>{name}</Title> */}
      {
        <ProjectFilter
          show={show}
          filters={filters}
          toogleFilter={toogleFilter}
        />
      }
      <div
        style={{ opacity: show ? 1 : 0, transition: "0.2s" }}
        className={styles.projectListContainer}
      >
        <ProjectsList
          setBlock={setBlock}
          projects={projetFilter}
          selected={selected}
          setSelected={setSelected}
        />
      </div>
    </>
  );
};

export default Projects;
